import { produce } from 'immer';
import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import {
  getDemandApisAction,
  getDemandApisBySubAccountUuidAction,
  getSecondLookOfferConfigurationsBySupplySubAccountIdAction,
} from './actions';
import type * as originatorActions from './actions';
import type { OriginatorState } from './types';

export const initialOriginatorState: OriginatorState = {
  demandApi: {
    byDemandSubAccountUuid: {},
    rows: [],
  },
  secondLookOfferConfiguration: {
    bySupplySubAccountId: {},
  },
};

export const originatorReducer = createReducer<
  OriginatorState,
  ActionType<typeof originatorActions>
>(initialOriginatorState)
  .handleAction(getDemandApisAction.success, (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.demandApi.rows = payload;
    })
  )
  .handleAction(
    getDemandApisBySubAccountUuidAction.success,
    (state, { payload: { demandApis, uuid } }) =>
      produce(state, (draft) => {
        draft.demandApi.byDemandSubAccountUuid[uuid] = demandApis;
      })
  )
  .handleAction(
    getSecondLookOfferConfigurationsBySupplySubAccountIdAction.success,
    (
      state,
      { payload: { supplySubAccountId, secondLookOfferConfigurations } }
    ) =>
      produce(state, (draft) => {
        draft.secondLookOfferConfiguration.bySupplySubAccountId[
          supplySubAccountId
        ] = secondLookOfferConfigurations;
      })
  );

export const originatorExternalReducer = combineReducers({
  originator: originatorReducer,
});
